import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var StarSolidIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M21.924 8.586A1.002 1.002 0 0021 7.968h-5.382l-2.724-5.46c-.34-.678-1.45-.678-1.79 0l-2.722 5.46H3a.998.998 0 00-.98 1.197c.038.195.133.373.273.513l4.584 4.594-1.838 6.449a1.004 1.004 0 00.94 1.275.998.998 0 00.575-.167L12 18.192l5.445 3.637a.996.996 0 001.502-.506c.066-.195.071-.405.014-.602l-1.838-6.449 4.584-4.594c.286-.285.37-.718.217-1.092z", fill: "currentColor" })] })));
};

export { StarSolidIcon };
//# sourceMappingURL=StarSolidIcon.js.map
